/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_Eligible_ProfilesInputs */

const en_task_settings_eligible_profiles = /** @type {(inputs: Task_Settings_Eligible_ProfilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eligible profiles`)
};

const pt_br2_task_settings_eligible_profiles = /** @type {(inputs: Task_Settings_Eligible_ProfilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfis elegíveis`)
};

/**
* | output |
* | --- |
* | "Eligible profiles" |
*
* @param {Task_Settings_Eligible_ProfilesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_eligible_profiles = /** @type {((inputs?: Task_Settings_Eligible_ProfilesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Eligible_ProfilesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_eligible_profiles(inputs)
	return pt_br2_task_settings_eligible_profiles(inputs)
});